import React, { useState, Fragment } from 'react';
import styled from 'styled-components';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import WindowCloseIcon from 'mdi-material-ui/WindowClose';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';

import { getDistributorModalStack } from 'features/distributor/actions';
import { DistributorMessage } from 'views/Checkout';

const SimpleDialogActions = styled(DialogActions)`
  margin-bottom: -56px;
`;

const DistributorModal = ({
  getDistributorModalStack,
  distributorModalStack,
  displayText
}) => {
  const [open, setOpen] = useState(false);

  function handleClickOpen() {
    getDistributorModalStack(Cookies.get('ip_country'));
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  return (
    <Fragment>
      <Button onClick={handleClickOpen} variant="contained" color="primary">
        {displayText}
      </Button>

      <Dialog
        id="distributorModal"
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
      >
        <SimpleDialogActions>
          <IconButton onClick={handleClose}>
            <WindowCloseIcon />
          </IconButton>
        </SimpleDialogActions>
        <DialogTitle>
          {distributorModalStack
            ? distributorModalStack.country_name
            : 'Distributor not found'}
        </DialogTitle>
        <DialogContent>
          <DistributorMessage entry={distributorModalStack} />
        </DialogContent>
      </Dialog>
    </Fragment>
  );
};

export default connect(
  state => ({
    distributorModalStack: state.distributor.distributorModalStack
  }),
  { getDistributorModalStack }
)(DistributorModal);
